export default function openLink(url: string, newTab = true) {
  return window.open(url, newTab ? '_blank' : '_self')
}
